(() => {
  const init = (root = document) => root.querySelectorAll('[data-ct-best-carousel]').forEach(carousel => {
    if (carousel.dataset.ctReady) return;
    const track = carousel.querySelector('[data-ct-best-track]');
    if (!track) return;
    const original = Array.from(track.children);
    if (!original.length) return;
    carousel.dataset.ctReady = 'true';
    const controls = carousel.querySelector('.ct-best-controls');
    const dots = carousel.querySelector('.ct-best-dots');
    const mobile = matchMedia('(max-width: 767px)');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let columns = 3, pages = 1, current = 0, scrollFrame;
    const update = () => {
      current = Math.min(pages - 1, Math.round(track.scrollLeft / track.clientWidth));
      Array.from(dots.children).forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
    };
    const go = page => {
      const target = (page + pages) % pages;
      track.scrollTo({left: target * track.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
    };
    const layout = () => {
      columns = mobile.matches ? 1 : 3;
      const ordered = original;
      ordered.forEach(el => track.appendChild(el));
      pages = Math.ceil(original.length / columns);
      dots.replaceChildren();
      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.className = 'ct-best-dot';
        dot.setAttribute('aria-label', `Afficher la page ${i + 1} sur ${pages}`);
        dot.addEventListener('click', () => go(i)); dots.appendChild(dot);
      }
      controls.hidden = pages <= 1;
      track.scrollTo({left: 0, behavior: 'instant'}); update();
    };
    carousel.querySelector('[data-ct-best-prev]').addEventListener('click', () => go(current - 1));
    carousel.querySelector('[data-ct-best-next]').addEventListener('click', () => go(current + 1));
    track.addEventListener('scroll', () => { cancelAnimationFrame(scrollFrame); scrollFrame = requestAnimationFrame(update); }, {passive: true});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    mobile.addEventListener('change', layout);
    layout();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
